import React from 'react';
import PropTypes from 'prop-types';
import { GetImage } from './LitImage';
import LitImage from './LitImage';
const LitBackgroundImage = ({
  children,
  src,
  className,
  tags,
  backgroundColour,
  image,
  fluid,
}) => {
  if (!src && backgroundColour && !image && !fluid) {
    return (
      <section
        className={className}
        style={{ backgroundColor: backgroundColour }}
      >
        {children}
      </section>
    );
  }

  // Using Art Direction
  if (!fluid) {
    if (image === null) return null;
    if (image === undefined) image = GetBackgroundImage(src);

    return (
      <LitImage
        Tag={tags}
        className={`${className}`}
        backgroundColor={backgroundColour}
        {...image}
        preserveStackingContext
        loading="eager"
      >
        {children}
      </LitImage>
    );
  } else {
    return (
      <LitImage
        Tag={tags}
        className={`${className}`}
        fluid={fluid}
        loading="eager"
      >
        {children}
      </LitImage>
    );
  }
};

LitBackgroundImage.propTypes = {
  src: PropTypes.string,
  className: PropTypes.string,
  tags: PropTypes.string,
  backgroundColour: PropTypes.string,
  children: PropTypes.node,
};

LitBackgroundImage.defaultProps = {
  className: '',
  tags: 'section',
  children: null,
  backgroundColour: 'transparent',
};

export function GetBackgroundImage(imageName) {
  console.log('Looking for Image', imageName);
  const image = GetImage(imageName);
  if (image === null) return null;
  return convertToBgImage(image.childImageSharp.gatsbyImageData);
}

export default LitBackgroundImage;
